import { Controller } from 'react-hook-form';
import { SettingsIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FormSectionV2, PersonaTextareaField } from '../../PersonaFormSectionsV2';
import { useCreatePersonaFormContext } from '../hooks/useCreatePersonaFormContext';

export function CustomRequirementsSectionV2() {
  const { t } = useTranslation('audiences');
  const { control } = useCreatePersonaFormContext();

  return (
    <FormSectionV2
      icon={<SettingsIcon className="size-5" />}
      title={t('audiences.customRequirementsSection.customRequirements')}
      description={t('audiences.customRequirementsSection.anyOtherSpecificRequirementsOr')}
    >
      <Controller
        name="customRequirement"
        control={control}
        render={({ field, fieldState: { error } }) => (
          <PersonaTextareaField
            {...field}
            label={t('audiences.customRequirementsSection.customRequirement')}
            placeholder={t('audiences.customRequirementsSection.enterCustomRequirement')}
            rows={6}
            error={error?.message}
          />
        )}
      />
    </FormSectionV2>
  );
}

CustomRequirementsSectionV2.displayName = 'CustomRequirementsSectionV2';
